
import { Crown, User, Shield, Dumbbell, ScanLine, ClipboardList } from "lucide-react";
import { Profile } from "@/hooks/profile/types";

interface MembershipBadgeProps {
  role: Profile['role'];
}

const getRoleConfig = (role: string) => {
  switch (role) {
    case 'admin':
      return {
        icon: Crown,
        label: 'Administrador',
        bgClass: 'from-amber-500/20 to-orange-500/10',
        textClass: 'text-amber-600 dark:text-amber-400',
        borderClass: 'border-amber-500/30'
      };
    case 'manager':
      return {
        icon: Shield,
        label: 'Manager',
        bgClass: 'from-blue-500/20 to-cyan-500/10',
        textClass: 'text-blue-600 dark:text-blue-400',
        borderClass: 'border-blue-500/30'
      };
    case 'profesor':
      return {
        icon: Dumbbell,
        label: 'Profesor',
        bgClass: 'from-violet-500/20 to-indigo-500/10',
        textClass: 'text-violet-600 dark:text-violet-400',
        borderClass: 'border-violet-500/30'
      };
    case 'monitor':
      return {
        icon: ScanLine,
        label: 'Monitor',
        bgClass: 'from-emerald-500/20 to-teal-500/10',
        textClass: 'text-emerald-600 dark:text-emerald-400',
        borderClass: 'border-emerald-500/30'
      };
    case 'recepcionista':
      return {
        icon: ClipboardList,
        label: 'Recepcionista',
        bgClass: 'from-pink-500/20 to-fuchsia-500/10',
        textClass: 'text-pink-600 dark:text-pink-400',
        borderClass: 'border-pink-500/30'
      };
    default:
      return {
        icon: User,
        label: 'Socio',
        bgClass: 'from-primary/15 to-primary/5',
        textClass: 'text-primary',
        borderClass: 'border-primary/20'
      };
  }
};

export const MembershipBadge = ({ role }: MembershipBadgeProps) => {
  const config = getRoleConfig(role);
  const Icon = config.icon;

  return (
    <div className={`
      flex items-center gap-3 p-4 rounded-xl
      bg-gradient-to-r ${config.bgClass}
      border ${config.borderClass}
      backdrop-blur-sm
    `}>
      <div className={`
        flex items-center justify-center w-10 h-10 rounded-full
        bg-background/80 ${config.borderClass} border
      `}>
        <Icon className={`h-5 w-5 ${config.textClass}`} />
      </div>
      <div className="flex flex-col">
        <span className="text-xs text-muted-foreground font-medium uppercase tracking-wide">
          Tipo de cuenta
        </span>
        <span className={`text-sm font-semibold ${config.textClass}`}>
          {config.label}
        </span>
      </div>
    </div>
  );
};
